// Copyright (c) 2017 Deere & Company

import t from 'tcomb';

const GridApi = t.struct({
    dateFields: t.list(t.String)
});

export const getDefaultState = () =>
    new GridApi({
        dateFields: [
            'creationDate',
            'submissionDate',
            'failureDate',
            'repairDate',
            'creditMemoDate',
            'originalSubmissionDate'
        ]
    });

export default GridApi;



// WEBPACK FOOTER //
// ./src/reports/special-allowance-claim-status/state/grid-api.js